var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudCheckFilled = function SvgCloudCheckFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.498 2.14c3.591-.662 7.184 1.166 8.734 4.437.14.296.41.504.742.57C21.466 7.843 24 10.937 24 14.5c0 4.136-3.364 7.5-7.5 7.5h-11a5.506 5.506 0 0 1-5.5-5.5 5.5 5.5 0 0 1 1.8-4.07c.274-.247.407-.591.347-.9a8.1 8.1 0 0 1-.033-2.89A7.95 7.95 0 0 1 8.498 2.14m8.043 8.354c-.265 0-.52.106-.708.293l-4.572 4.258a1.026 1.026 0 0 1-1.411 0l-2.572-2.478a1 1 0 1 0-1.416 1.4l2.575 2.485a2.98 2.98 0 0 0 2.12.88 2.98 2.98 0 0 0 2.118-.873l4.573-4.258a1 1 0 0 0-.707-1.707",
    clipRule: "evenodd"
  })));
};
export default SvgCloudCheckFilled;